module.exports = __webpack_public_path__ + "img/account_heart.b6c955a8.svg";